import { useMutation, useQueryClient } from 'react-query';

import { usersKey } from '../../key';
import { axiosInstance } from '../../base';

const apiUrl = '/users';

const deleteUserEquipment = async (requestData) => {
  const response = await axiosInstance.delete(`${apiUrl}/${requestData.rid}/equipments/${requestData.equipmentRid}`);
  return response;
};

export const useDeleteUserEquipment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUserEquipment,
    onSuccess: () => {
      queryClient.invalidateQueries(usersKey.all);
    },
  });
};
